export default "__VITE_ASSET__B8cRUx_M__"